import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import type Owner from '@ember/owner';
import type IntlService from 'ember-intl/services/intl';
import type { htmlSafe } from '@ember/template';
type SafeString = ReturnType<typeof htmlSafe>;

export interface AditoolsConfirmationDialogSignature {
  Element: HTMLDivElement;
  Args: {
    title: string | SafeString;
    message?: string | SafeString;
    confirm: () => void;
    close: () => void;
    closeButtonText?: string;
    confirmButtonText?: string;
    dialogClass?: string;
  };
  Blocks: {
    default: [];
  };
}
type AditoolsConfirmationDialogArgs = AditoolsConfirmationDialogSignature['Args'];
export default class AditoolsConfirmationDialog extends Component<AditoolsConfirmationDialogSignature> {
  @service declare intl: IntlService;

  constructor(owner: Owner, args: AditoolsConfirmationDialogArgs) {
    super(owner, args);
    assert('`title` is required', !isNone(this.args.title));
    assert('`confirm` is required', !isNone(this.args.confirm));
    assert('`close` is required', !isNone(this.args.close));
  }

  @action confirmDialog(closeDialog: () => void) {
    this.args.confirm();
    closeDialog();
  }

  // Optional parameters with defaults applied
  get _confirmButtonText() {
    return this.args.confirmButtonText ?? this.intl.t('ember-aditools-page.common.ok');
  }

  get _closeButtonText() {
    return this.args.closeButtonText ?? this.intl.t('ember-aditools-page.common.cancel');
  }
}
